import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import RegisterForm from '../../components/forms/RegisterForm';
import NetworkBackground from '../../components/NetworkBackground';
import Toast from '../../components/Toast';
import authService from '../../services/authService';
import styles from './RegisterPage.module.css';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  const handleRegister = async (credentials) => {
    const result = await authService.register(credentials);
    if (result.success) {
      setToast({ message: 'Account created. Check your email to verify before logging in.', type: 'success' });
      setTimeout(() => navigate('/login'), 3000);
    } else {
      setToast({ message: result.error || 'Registration failed. Please try again.', type: 'error' });
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.card}>
        <RegisterForm onRegister={handleRegister} />

        <div className={styles.footerText}>
          Already have an account? <Link to="/login">Login</Link>
        </div>
        <div className={styles.footerText}>
          Already on Nodel? Ask your admin to invite you instead of registering.
        </div>
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
